export const getFullName = (firstName = '', lastName = '') => `${firstName} ${lastName}`;
